import React, { useRef } from "react";
import Layout from "../../layout/Layout";

function Premium() {
  const destinations = [
    {
      name: "Eiffel Tower",
      visits: "1.2M Visits",
      imageUrl: "https://placehold.co/200x200/5C88F0/ffffff?text=Eiffel+Tower",
    },
    {
      name: "Machu Picchu",
      visits: "850K Visits",
      imageUrl: "https://placehold.co/200x200/5C88F0/ffffff?text=Machu+Picchu",
    },
    {
      name: "Great Wall",
      visits: "2.5M Visits",
      imageUrl: "https://placehold.co/200x200/5C88F0/ffffff?text=Great+Wall",
    },
    {
      name: "Statue of Liberty",
      visits: "1.5M Visits",
      imageUrl:
        "https://placehold.co/200x200/5C88F0/ffffff?text=Statue+of+Liberty",
    },
    {
      name: "Taj Mahal",
      visits: "1.8M Visits",
      imageUrl: "https://placehold.co/200x200/5C88F0/ffffff?text=Taj+Mahal",
    },
    {
      name: "Opera House",
      visits: "900K Visits",
      imageUrl: "https://placehold.co/200x200/5C88F0/ffffff?text=Opera+House",
    },
    {
      name: "Colosseum",
      visits: "1.1M Visits",
      imageUrl: "https://placehold.co/200x200/5C88F0/ffffff?text=Colosseum",
    },
    {
      name: "Grand Canyon",
      visits: "1.3M Visits",
      imageUrl: "https://placehold.co/200x200/5C88F0/ffffff?text=Grand+Canyon",
    },
  ];

  const carouselRef = useRef(null);

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -250, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 250, behavior: "smooth" });
    }
  };

  const destination = [
    {
      name: "Down South",
      tours: 356,
      activities: 248,
      promotions: 25,
      imageUrl: "https://placehold.co/800x600/5C88F0/ffffff?text=Down+South",
    },
    {
      name: "Badulla Srilanka",
      tours: 356,
      activities: 248,
      imageUrl:
        "https://placehold.co/800x600/5C88F0/ffffff?text=Badulla+Srilanka",
    },
    {
      name: "Sigiriya Srilanka",
      tours: 356,
      activities: 248,
      imageUrl:
        "https://placehold.co/800x600/5C88F0/ffffff?text=Sigiriya+Srilanka",
    },
    {
      name: "Gali Srilanka",
      tours: 356,
      activities: 248,
      imageUrl: "https://placehold.co/800x600/5C88F0/ffffff?text=Gali+Srilanka",
    },
    {
      name: "Matara Srilanka",
      tours: 356,
      activities: 248,
      imageUrl:
        "https://placehold.co/800x600/5C88F0/ffffff?text=Matara+Srilanka",
    },
     {
      name: "Matara Srilanka",
      tours: 356,
      activities: 248,
      imageUrl:
        "https://placehold.co/800x600/5C88F0/ffffff?text=Matara+Srilanka",
    },
  ];

  const scrollRef = useRef(null);

  const scrollLeftTrending = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRightTrending = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const padNumber = (num) => String(num).padStart(2, "0");
  const now = new Date();
  const targetDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 3,
    now.getHours() + 22,
    now.getMinutes() + 9,
    now.getSeconds() + 45
  );

  const calculateTimeLeft = () => {
    const difference = +targetDate - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft());

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  return (
    <Layout>
      {/* Hero Section */}
      <div
        className="w-full h-screen bg-cover bg-center"
        style={{ backgroundImage: "url('/Trending.jpg')" }}
      >
        <div className="w-full h-full bg-black opacity-10 absolute top-0 left-0"></div>
        <div className="w-full h-full flex items-center text-white">
          <div className="px-10">
            <h1 className="text-[55px] font-extrabold leading-tight">
              Premium Travel Experiences
            </h1>
            <p className="mt-4 text-xl leading-relaxed max-w-2xl">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              <br />
              Qui magnam minima velit perferendis ad quae consequatur,
              <br />
              impedit suscipit? Nihil asperiores animi consectetur,
              <br />
              atque molestiae quidem hic assumenda in eum, mollitia,
              <br />
              quos nostrum aliquam. Dicta eius qui minima nesciunt
              <br /> dignissimos provident cumque hic mollitia nam, ut aliquid
              <br /> doloribus beatae dolorum accusantium!
            </p>
          </div>
        </div>
      </div>

      {/* Payment Methods */}
      <div className="bg-white p-8 lg:p-16 rounded-3xl shadow-2xl flex flex-col items-center">
        <div className="flex flex-wrap justify-center items-center space-x-8">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg"
            alt="PayPal"
            className="h-8"
          />
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg"
            alt="Stripe"
            className="h-8"
          />
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg"
            alt="Visa"
            className="h-8"
          />
        </div>
      </div>

      {/* Popular Destinations */}
      <div className="flex flex-col items-center justify-center bg-gray-50 font-sans">
        <div className="text-center mb-10">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-2">
            Popular Destinations
          </h1>
          <p className="text-lg text-gray-600">
            Navigate the Globe with Confidence
          </p>
        </div>

        <div className="w-full max-w-6xl relative">
          <button
            onClick={scrollLeft}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white text-gray-700 p-2 rounded-full shadow-lg z-10 hover:bg-gray-200 transition-colors duration-300"
            aria-label="Scroll left"
          >
            ◀
          </button>

          <div
            ref={carouselRef}
            className="flex space-x-6 p-4 overflow-x-auto scroll-smooth hide-scrollbar"
          >
            {destinations.map((destination, index) => (
              <div
                key={index}
                className="flex-none w-48 text-center rounded-lg overflow-hidden cursor-pointer"
              >
                <div className="relative w-40 h-40 mx-auto">
                  <img
                    src={destination.imageUrl}
                    alt={destination.name}
                    className="rounded-full w-full h-full object-cover shadow-xl transition-transform duration-300 hover:scale-105"
                  />
                </div>
                <div className="mt-4">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {destination.name}
                  </h3>
                  <p className="text-sm text-gray-500">{destination.visits}</p>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={scrollRight}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white text-gray-700 p-2 rounded-full shadow-lg z-10 hover:bg-gray-200 transition-colors duration-300"
            aria-label="Scroll right"
          >
            ▶
          </button>
        </div>

        <style>{`
          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}</style>
      </div>

      {/* Trending Destinations */}
      <div className="flex flex-col items-center justify-center min-h-screen bg-white text-gray-800 p-6 font-sans">
        <div className="text-center mb-10">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-2">
            Trending Destinations
          </h1>
          <p className="text-lg text-gray-600">
            Most popular choices for travelers
          </p>
        </div>

        <div className="w-full max-w-6xl">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* First Destination with countdown */}
            <div className="relative md:col-span-2 lg:col-span-1 rounded-3xl overflow-hidden shadow-2xl group cursor-pointer">
              <img
                src={destination[0].imageUrl}
                alt={destination[0].name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black via-transparent to-transparent p-6">
                <h3 className="text-white text-2xl font-bold mb-1">
                  {destination[0].name}
                </h3>
                <p className="text-gray-200 text-sm">
                  {destination[0].tours} Tours, {destination[0].activities}{" "}
                  Activities
                </p>
              </div>
             
            </div>

            {/* Other Destinations */}
            {destination.slice(1).map((d, i) => (
              <div
                key={i}
                className="relative rounded-3xl overflow-hidden shadow-2xl group cursor-pointer"
              >
                <img
                  src={d.imageUrl}
                  alt={d.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black via-transparent to-transparent p-6">
                  <h3 className="text-white text-xl font-bold mb-1">{d.name}</h3>
                  <p className="text-gray-200 text-sm">
                    {d.tours} Tours, {d.activities} Activities
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Premium;
